import { IGetCompanyDetailsResponseDataObj } from "../../../types/pub";
import { IFundingHistory } from "../../../types/shared";
import { HoverAction } from "../components/Credential/AssignmentsTable/HoverActionCell/HoverActionCell";
import { AssignmentsTableDataByRef, GroupedAssignments } from "../components/Credential/Presentation/types/common";
import { AssignmentTableColumnsKeysType } from "../util/common";
import { RRA_INDUSTRY } from "../util/constants";
import { CredRef, IBaseCredentialMetaData, IUseCreatedCredentialFields, TEMPLATE_META_DATA } from "./credential";
import { CredLogo, CredLogoSource, IProject } from "./project";

export enum CREDENTIAL_TAB_KEYS {
  'all_assignments' = 'all-assignments',
  'saved_assignments' = 'saved-assignments',
  'presentation' = 'presentation'
}

export const DEFAULT_TAB = CREDENTIAL_TAB_KEYS.all_assignments;


export interface IAssignmentCompanyDetails {
  company_details: IGetCompanyDetailsResponseDataObj['company'];
  capiq_details: IGetCompanyDetailsResponseDataObj['capiq'];
}
export interface IAssigmentsTableData extends IProject, Partial<IAssignmentCompanyDetails> {

}

// Type derived from IAssigmentsTableData with all fields partial except ref, and client_company.company_id
export type IAssigmentsTableDataWithRequiredIds = Partial<IAssigmentsTableData> & {
  ref: IAssigmentsTableData['ref'];
  client_company: Pick<IAssigmentsTableData['client_company'], 'company_id'> & Partial<Omit<IAssigmentsTableData['client_company'], 'company_id'>>;
};

export interface IFunding extends Omit<IFundingHistory, 'amount'> {
  amount: number | undefined;
}

export interface IAssignmentsTableProps {
  hoverAction: HoverAction;
  pageSize: number;
  credRef: CredRef;
  data: IAssigmentsTableData[];
  joid: string;
  currentPage: number;
  isRRAUser: boolean;
  count: number;
  onAction?: () => void;
  isLoading?: boolean;
  handleIncrementPage: () => void;
  handleDecrementPage: () => void;
  search: string;
  handleSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export type CredentialsViewMode = 'list' | 'grid';

export interface IUpdateCredentialHandlerParams extends Omit<IUseCreatedCredentialFields, 'type'> { // type is deprecated - https://findemjira.atlassian.net/browse/RRINT-1839
  onEnd?: () => void;
}

export type UpdateCredentialHandler = (params: IUpdateCredentialHandlerParams) => void | Promise<void>;
export type CreateCredentialHandler = () => Promise<void>;

export type SortGroupedAssignmentKeys = (params: {
  groupedAssignment: AssignmentsTableDataByRef;
}) => string[];

export type RRA_INDUSTRY_VALUES = typeof RRA_INDUSTRY[number];

export type IGetAssignmentTableMappedColumnValueParams = (params: {
  key: AssignmentTableColumnsKeysType;
  data: IAssigmentsTableDataWithRequiredIds;
  assignmentFieldsOverride: IBaseCredentialMetaData['assignment_fields_override'];
  shouldOnlyCheckOverrides?: boolean; // used if assignment was manually uploaded
}) => {
  formattedValue: string | number | undefined;
  unformattedValue: string | number | undefined;
}

export type SortGroupedAssignments = (params: {
  sortingState: TEMPLATE_META_DATA['sorting_state'];
  assignmentFieldsOverride: IBaseCredentialMetaData['assignment_fields_override'];
  groupedAssignments: GroupedAssignments[];
  gridTemplateAreas: string | undefined;
  sortAgainstCurrentTemplate?: boolean;
}) => {
  sortedGroupedAssignments: GroupedAssignments[];
}

export type GetPrimaryLogoUrl = (params: {
  logos: CredLogo[] | undefined;
  source?: CredLogoSource;
}) => {
  logo: CredLogo | undefined;
  url: string | undefined;
};
